<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="sampleSetForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="sampleSet" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                sampleSetForm: () => import('../forms/SampleSetForm'),
                sampleSet: () => import('../editViews/SampleSet'),
                headers: [
                    { text: 'Lab Client Organisation', value: 'labClientOrganisationId', table: 'labClientOrganisations', form: () => import('../forms/LabClientOrganisationForm') },
                    { text: 'Samples To Be Mailed On', value: 'samplesToBeMailedOn', format: this.formatDate },
                    { text: 'Completed On', value: 'completedOn', format: this.formatDate },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    labClientOrganisations: [],
                    items: []
                },
                sorting: [
                    { column: "samplesToBeMailedOn", direction: "descending" },
                    { column: "labClientOrganisationId", direction: "ascending" },
                ],
                itemsField: 'sampleSets',
                editPageName: 'sampleSet',
                apiMethod: 'SampleSets',
                claimName: 'SampleSets',
                formTitle: 'Sample Set',
                excelTitle: 'Sample Sets',
                hasEditPage: true,
            }
        },
    };
</script>
